import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterNavigation from './components/ClusterNavigation';
import QuickLeadSection from './components/QuickLeadSection';
import WhatIsAssessment from './components/WhatIsAssessment';
import TasksSolved from './components/TasksSolved';
import WhenNeeded from './components/WhenNeeded';
import WhatToAssess from './components/WhatToAssess';
import AssessmentFormats from './components/AssessmentFormats';
import AssessmentProcess from './components/AssessmentProcess';
import FromAssessmentToDevelopment from './components/FromAssessmentToDevelopment';
import IndividualPlans from './components/IndividualPlans';
import TalentPool from './components/TalentPool';
import AssessmentVsTrainingEval from './components/AssessmentVsTrainingEval';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import SuitableFor from './components/SuitableFor';
import AboutTrainer from './components/AboutTrainer';
import RelatedClusters from './components/RelatedClusters';
import StudyFurtherSection from './components/StudyFurtherSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import RoiCtaStrip from '@/components/feature/RoiCtaStrip';
import Footer from '@/components/feature/Footer';

const hubNavLinks = [
  { label: 'Задачи', target: 'tasks' },
  { label: 'Форматы', target: 'formats' },
  { label: 'Процесс', target: 'process' },
  { label: 'FAQ', target: 'faq' },
];

export default function AssessmentDevelopmentPage() {
  return (
    <>
      
      <SeoTitle title="Оценка и развитие сотрудников | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={hubNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />

        <div id="cluster">
          <ClusterNavigation />
        </div>

        <QuickLeadSection />
        <WhatIsAssessment />

        <div id="tasks">
          <TasksSolved />
        </div>

        <WhenNeeded />
        <WhatToAssess />

        <div id="formats">
          <AssessmentFormats />
        </div>

        <div id="process">
          <AssessmentProcess />
        </div>

        <FromAssessmentToDevelopment />
        <IndividualPlans />
        <TalentPool />
        <AssessmentVsTrainingEval />
        <RoiCtaStrip />
        <WhyProgramsWork />
        <CompanyResults />
        <SuitableFor />
        <AboutTrainer />
        <RelatedClusters />
        <LeadMagnetBlock variant="compact" />
        <StudyFurtherSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </div>
    </>
  );
}